module.exports = __webpack_public_path__ + "img/stars.614a38d1.svg";